import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";
import clsx from "clsx";

const DateClockIcon = ({ sx, className, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={clsx("qi-icon qi-icon-date-clock", className)}
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M10.6934 19.339L5 19.339C3.34315 19.339 2 17.9959 2 16.339V8.24783M19.3869 10.5413V8.24783M2 8.24783V6.75519C2 5.09833 3.34315 3.75519 5 3.75519H16.3869C18.0437 3.75519 19.3869 5.09833 19.3869 6.75519V8.24783M2 8.24783H19.3869"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M5.86017 2.16211V5.16433"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M15.3927 2.25653V5.25875"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M21.9999 17.1806C21.9999 18.3851 21.5426 19.4828 20.7921 20.3095C19.9402 21.2479 18.7106 21.8372 17.3433 21.8372C14.7715 21.8372 12.6866 19.7524 12.6866 17.1806C12.6866 14.6088 14.7715 12.5239 17.3433 12.5239C19.9151 12.5239 21.9999 14.6088 21.9999 17.1806Z"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0836 15.5175V17.6853L18.6 18.357"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.72101 11.3874L10.6936 11.3874L12.6662 11.3874"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default memo(DateClockIcon);
